import {
  ARBITRATION_PAGE_LOADER,
  DOWNLOAD_COUNT,
  SET_ARBITRATION_PAGE_DATA,
} from "../actionTypes";

const initialState = {
  loader: false,
  arbitrationPageData: {},
};

const arbitrationPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ARBITRATION_PAGE_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_ARBITRATION_PAGE_DATA: {
      return {
        ...state,
        arbitrationPageData: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          arbitrationPageData: {
            ...state.arbitrationPageData,
            fileViewCount: (state.arbitrationPageData?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          arbitrationPageData: {
            ...state.arbitrationPageData,
            downloadCount: (state.arbitrationPageData?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default arbitrationPageReducer;
